import React from 'react';
import { reduxForm, Field } from 'redux-form';

import { requestResetCode } from '../actions';

import Form from 'forms/Form';
import InputField from 'forms/InputField';
import Box from 'common/Box';

export const RequestResetCodeForm = (props) => (
  <div className="RequestResetCodeForm">
    <Box>
      <Form {...props} submit="Request Code">
        <Field component={InputField} name="email" label="Your email address" />
      </Form>
    </Box>
  </div>
);

export default reduxForm({
  form: 'requestResetCode',
  onSubmit: requestResetCode,
})(RequestResetCodeForm);

